module.exports = __webpack_public_path__ + "static/media/Robotbanner@3x.41693426.png";